import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Auth from "./component/auth/Auth";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// const TheLayout = React.lazy(() => import("./containers/Layout"));
const NewLayout = React.lazy(() => import("./containers/new-layout"));
const Register = React.lazy(() => import("./views/pages/Register"));
const Page401 = React.lazy(() => import("./views/pages/page401/page401"));
class App extends Component {
  render() {
    return (
      <Auth>
        <BrowserRouter>
          <React.Suspense fallback={loading}>
            <Switch>
              <Route
                exact
                path="/401"
                name="Page 401"
                render={(props) => <Page401 {...props} />}
              />
              <Route
                path="/register"
                name="หน้าแรก"
                render={(props) => <Register {...props} />}
              />
              <Route
                path="/"
                name="หน้าแรก"
                render={(props) => <NewLayout {...props} />}
              />
            </Switch>
          </React.Suspense>
        </BrowserRouter>
      </Auth>
    );
  }
}

export default App;
